module.exports = __webpack_public_path__ + "static/media/rule_of_verb_accent_img.e67c2e4f.JPG";